import React from 'react';
import moment from 'moment';
import { ClientContext } from '~/services';
import { handleButtonKeypress } from '~/util';

const currentYear = moment().year();
const priorYear = moment().subtract(1, 'years').year();

function ReportYear() {
    const client = React.useContext(ClientContext);

    return (
        client.isReportYearAvailable && (
            <div id="year-toggle">
                <div
                    id="py"
                    className={client.reportYear === priorYear ? 'selected' : undefined}
                    onClick={() => client.setReportYear(priorYear)}
                    onKeyUp={(e) => handleButtonKeypress(e, () => client.setReportYear(priorYear))}
                    role="button"
                    tabIndex={0}
                >
                    <span>{priorYear}</span>
                    {client.reportYear === priorYear && <span>(selected)</span>}
                </div>
                <div
                    id="cy"
                    className={client.reportYear === currentYear ? 'selected' : undefined}
                    onClick={() => client.setReportYear(currentYear)}
                    onKeyUp={(e) =>
                        handleButtonKeypress(e, () => client.setReportYear(currentYear))
                    }
                    role="button"
                    tabIndex={0}
                >
                    <span>{currentYear}</span>
                    {client.reportYear === currentYear && <span>(selected)</span>}
                </div>
            </div>
        )
    );
}

export { ReportYear };
